import Feature from './feature';

function loadImage(map, imageId, imageUrl) {
  return new Promise((resolve) => {
    if (map.hasImage(imageId)) {
      resolve()
    } else {
      map.loadImage(imageUrl, (error, image) => {
        map.addImage(imageId, image)
        resolve()
      })
    }
  })
}
const Point = function (ctx, geojson) {
  const { properties } = geojson
  if (properties['image-id'] && properties['image-url']) {
    loadImage(ctx.map, properties['image-id'], properties['image-url'])
  }
  Feature.call(this, ctx, geojson);
};

Point.prototype = Object.create(Feature.prototype);

Point.prototype.isValid = function () {
  return typeof this.coordinates[0] === 'number' &&
    typeof this.coordinates[1] === 'number';
};

Point.prototype.updateCoordinate = function (pathOrLng, lngOrLat, lat) {
  if (arguments.length === 3) {
    this.coordinates = [lngOrLat, lat];
  } else {
    this.coordinates = [pathOrLng, lngOrLat];
  }
  this.changed();
};

Point.prototype.getCoordinate = function () {
  return this.getCoordinates();
};

export default Point;
